import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const UploadArrowIcon = ({
  title = 'UploadArrowIcon',
  className = 'upload-arrow-icon',
  viewBox = '0 0 14 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2218 1.59809C13.2218 1.16854 12.8736 0.820312 12.444 0.820312H1.55512L1.49707 0.822446C1.09463 0.852137 0.777344 1.18806 0.777344 1.59809C0.777344 2.02765 1.12557 2.37587 1.55512 2.37587H12.444L12.5021 2.37374C12.9045 2.34404 13.2218 2.00812 13.2218 1.59809ZM11.5366 7.67421C11.8414 7.9769 11.8431 8.46935 11.5404 8.77414C11.2515 9.06508 10.7896 9.07986 10.4832 8.81734L10.4405 8.77795L7.87476 6.22959L7.77537 14.5411C7.77024 14.9706 7.41787 15.3147 6.98835 15.3095C6.57835 15.3046 6.24625 14.9833 6.22137 14.5806L6.21993 14.5225L6.31857 6.27302L3.79661 8.77795C3.50568 9.06688 3.04374 9.07846 2.73909 8.81383L2.69667 8.77414C2.40775 8.48321 2.39616 8.02128 2.6608 7.71662L2.70048 7.67421L7.11854 3.28662L11.5366 7.67421Z"
      fill="#505050"
    />
  </CreateIconComponent>
);

export default UploadArrowIcon;
